import {
  MAX_DEFAULT_BUDGET,
  MIN_DEFAULT_BUDGET,
  getPriceWithCurrency,
} from '@/helpers/priceHelper'

export const useSearchClientHeader = () => {
  const { t, locale } = useI18n({ useScope: 'global' })

  const { currency } = useUser()
  const { maxBudget, minBudget } = useSearchBudgetFilters()
  const { bathrooms, bedrooms } = useSearchNumericFilters()

  const hasRooms = computed(() => bathrooms.value > 0 || bedrooms.value > 0)

  const roomsFormatted = computed(() => {
    return [
      ...(bedrooms.value
        ? [t('search.filterBlock.bedrooms', { count: bedrooms.value })]
        : []),
      ...(bathrooms.value
        ? [t('search.filterBlock.bathrooms', { count: bathrooms.value })]
        : []),
    ].join(', ')
  })

  const budgetFormatted = computed(() => {
    const maxFormatted = getPriceWithCurrency({
      price: Number(maxBudget.value),
      currency: currency.value,
      i18n: { locale },
    })
    const minFormatted = getPriceWithCurrency({
      price: Number(minBudget.value),
      currency: currency.value,
      i18n: { locale },
    })

    if (
      maxBudget.value !== MAX_DEFAULT_BUDGET &&
      minBudget.value !== MIN_DEFAULT_BUDGET
    ) {
      return t('search.filterBlock.rangePrice', {
        max: maxFormatted,
        min: minFormatted,
      })
    } else if (maxBudget.value !== MAX_DEFAULT_BUDGET) {
      return t('search.filterBlock.maxPrice', { max: maxFormatted })
    } else {
      return t('search.filterBlock.minPrice', { min: minFormatted })
    }
  })

  return { hasRooms, roomsFormatted, budgetFormatted }
}
